export default __webpack_public_path__ + "static/media/Background 5_00020.d694103b.png";